<!--
확장형 input 요소의 테이블(td) 스타일
-->
<template>
    <div class="container" :class="cssClass" :style="[computedCssVariables]">
        <div class="w-full uk-flex uk-flex-left">
            <label
                class="uk-flex uk-flex-middle uk-flex-left"
                :class="labelClassObject"
                @click="inputFocus"
                v-if="label"
            >
                <!-- 필수 -->
                <span v-if="required" class="required-text">{{ requiredText }}</span>




                <!-- 라벨 -->
                <div class="label-text">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </div>

                <!-- 검증상태 -->
                <span v-show="validateState === 'success'" class="validate-success-sign ml-0d5rem" :uk-icon="'icon: check; ratio: ' + validateSuccessSignRatio"></span>



            </label>

            <div class="uk-width-expand input-div">
                <!-- input 영역 상위 100% 한줄 -->
                <slot name="input-top">
                </slot>

                <div class="uk-flex uk-flex-left">
                    <component

                        :is="componentName"
                        ref="input"

                        class="input-component"
                        :class="inputCssClass"

                        :id="id"
                        :name="name"
                        :placeholder="placeholder"
                        :css-variables="inputCssVariables"
                        :multiselect-class="multiselectClass"

                        :text="text"

                        :value="value"
                        @update:value="updateValue"
                        :input-size="inputSize"
                        :validate-rules="validateRules"
                        :options=" options"
                        :init-error-msg="initErrorMsg"
                        :textarea-rows="textareaRows"
                        :readonly="readonly"
                        :disabled="disabled"

                        @update:state="updateState"
                        @update:is-focus="updateIsFocus"
                    >
                        <!-- 라디오,체크박스 에서 사용하는 옵션명 커스텀정의 슬롯 -->
                        <template
                            slot="optionText"
                            slot-scope="{ option }"
                        >
                            <slot
                                name="optionText"
                                :option="option"
                            >
                                {{ option.text }}
                            </slot>
                        </template>

                        <!-- 커스텀 placeholder 정의 슬롯 -->
                        <template
                            slot="customPlaceholder"
                        >
                            <slot
                                name="customPlaceholder"
                            >
                            </slot>
                        </template>
                    </component>

                    <!-- input 영역 오른쪽 -->
                    <slot name="input-right">
                    </slot>
                </div>

                <!-- input 영역 하단 100% 한줄 -->
                <slot name="input-bottom">
                </slot>
            </div>

            <!-- 추가요소 -->
            <slot name="additional">

            </slot>
        </div>


        <!-- 에러메세지 -->
        <div v-show="errorMsg" class="error-msg">
            {{ errorMsg }}
        </div>

        <!-- 설명메세지 -->
        <div v-show="descMsg" class="desc-msg">
            {{ descMsg }}
        </div>

        <!-- 아래쪽 100% 차지하는 추가요소 -->
        <slot name="bottom">

        </slot>

    </div>
</template>

<script>
    import ExBase from './base.vue';

    export default {
        extends: ExBase,

        computed: {
            /**
             * 디폴트 css 변수정의
             */
            defaultCssVariables: function () {
                return _.assignIn(ExBase.computed.defaultCssVariables(), {
                    '--label-width': '10rem',
                    '--label-highlight-bg-color': '#ffff99',
                    '--input-div-min-width': '10rem',
                    '--input-width': null,

                });
            },

            /**
             * css 변수 상속처리
             */
            computedCssVariables: function () {
                return _.assignIn(this.defaultCssVariables, this.cssVariables);
            },

            /**
             * input요소에 전달할 css 변수정의
             */
            inputCssVariables: function () {
                return {
                    '--bg-color': this.highlighted ? '#ffff99' : '#fff'
                };
            },

            /**
             * 전체 컴포넌트에 정의될 css 클래스명
             */
            cssClass: function () {
                let classes =  {
                    'highlight': this.highlighted,
                };
                classes[this.componentName] = true;
                return classes;
            },

            /**
             * input 컴포넌트에 전달될 css 클래스명
             */
            inputCssClass: function () {
                let classes =  {};

                // input요소의 width css 변수가 선언되어있지 않으면 기본적으로 width 확장처리
                if (! this.computedCssVariables['--input-width']) {
                    classes['uk-width-expand'] = true;
                }

                return classes;
            },

            /**
             * 하이라이트 적용여부
             * @returns boolean
             */
            highlighted() {
                return this.highlight
                    || (this.required && this.requiredLayout === 'label-highlight');
            },


            /**
             * 정의된 타입별 컴포넌트 네임을 반환
             */
            componentName: function () {
                return 'app-input-' + this.type;
            },

            /**
             * 검증성공 체크표시의 사이즈 (ratio 속성)
             */
            validateSuccessSignRatio: function () {
                if (this.inputSize === 'small') {
                    return '0.8';
                } else if (this.inputSize === 'large') {
                    return '1.2';
                }
                return '1';
            },
            
        }
    }
</script>


<style lang="scss" scoped>
// 검증성공 체크표시
.validate-success-sign {
    color: #009a67;
}

// 오류메세지
.error-msg{
    color: #f0506e ;
    font-size: 0.75rem;
    text-align: right;
}

// 설명
.desc-msg{
    color: #999;
    font-size: 0.75rem;
    text-align: right;
}

// 기본상태
label {
    border: 1px solid #e5e5e5;
    border-right: 0;
    background-color: #fafafa;
    width: var(--label-width);
    color: #000;

    position: relative;

    span.required-text {
        color: red;
        position: absolute;
        left: 0.5rem;
        top: 0.5rem;
    }

    .label-text {
        margin-left: 1.5rem;

    }
}



// 하이라이트
.highlight {
    label {
        //--bg-color: #ffff99;
        //font-size: 1rem;
        color: #000 !important;

        font-weight: bold;




        .label-text {
            background-color: var(--label-highlight-bg-color);
        }
    }

}

// input 영역
.input-div {
    min-width: var(--input-div-min-width);

    // input 컴포넌트
    .input-component {
        width: var(--input-width);
    }
}



// text, textarea 제외하고 border 표시
.container:not(.app-input-text):not(.app-input-textarea) > div > .input-div{
    border: 1px solid #e5e5e5;
    padding-left: 1rem;

}

</style>